import React from "react";
import { Spinner } from "reactstrap";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="status d-flex justify-content-center align-items-center">
        <Spinner color="primary" />
      </div>
    </div>
  );
};

export default Loader;
